<template>
    <div>
        <az-toolbar>
            <template v-slot:simpleSearch>
                <v-flex>
                    <az-search
                        :filter="filtrosInterno"
                        @remove-filter="tratarEventoRemoverFiltro"
                        @simple-search="tratarEventoBuscaSimples"
                        id="azSearch"
                        simple-search-placeholder="Busque por: Código, órgão ou situação"
                    />
                </v-flex>
            </template>
        </az-toolbar>
        <div class="az-form-content">
            <movimentacao-baixa-listagem-tabela
                :itens="itens"
                :paginacao="$store.state.movimentacao.todasMovimentacoesBaixas.paginacao"
                :paginas="paginas"
                :total-itens="totalItens"
                @acessar="tratarEventoAcessar"
                @paginar="tratarEventoPaginar"
            />
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {actionTypes, mutationTypes} from '@/core/constants'
    import {mapActions, mapMutations} from 'vuex'
    import MovimentacaoBaixaListagemTabela from './MovimentacaoBaixaListagemTabela.vue'

    export default {
        name: 'MovimentacaoBaixaListagem',
        components: {MovimentacaoBaixaListagemTabela},
        data() {
            return {
                filtrosInterno: this.getFiltros(),
                itens: [],
                paginas: 0,
                totalItens: 0
            }
        },
        async mounted() {
            await this.buscar()
        },
        methods: {
            ...mapActions([
                actionTypes.MOVIMENTACAO.BAIXA.BUSCAR_TODAS_MOVIMENTACOES_BAIXAS
            ]),
            ...mapMutations([
                mutationTypes.MOVIMENTACAO.BAIXA.SET_FILTROS_BUSCAR_TODAS_MOVIMENTACOES_BAIXAS,
                mutationTypes.MOVIMENTACAO.BAIXA.SET_PAGINACAO_BUSCAR_TODAS_MOVIMENTACOES_BAIXAS,
                mutationTypes.MOVIMENTACAO.BAIXA.RESETA_PAGE_BUSCAR_TODAS_MOVIMENTACOES_BAIXAS
            ]),
            async buscar() {
                this.setFiltrosBuscarTodasMovimentacoesBaixas(this.getFiltrosInterno())
                await this.buscaTodasBaixas()
            },
            async buscaTodasBaixas() {

                const resultado = await this.buscarTodasMovimentacoesBaixas()
                if (resultado) {
                    this.itens = resultado.items
                    this.paginas = resultado.totalPages
                    this.totalItens = resultado.totalElements
                }
            },
            getFiltros() {
                return _.cloneDeep(this.$store.state.movimentacao.todasMovimentacoesBaixas.filtros)
            },
            getFiltrosInterno() {
                return _.cloneDeep(this.filtrosInterno)
            },
            tratarEventoAcessar(item) {
                if (item.situacao === 'EM_ELABORACAO') {
                    this.$router.push({
                        name: 'NovaMovimentacao',
                        params: {id: item.patrimonio},
                        query: {rotaName: 'MovimentacaoBaixaListagem'}
                    })
                } else {
                    this.$router.push({
                        name: 'MovimentacaoDetalhe',
                        params: {id: item.id},
                        query: {rotaName: 'MovimentacaoBaixaListagem'}
                    })
                }
            },
            async tratarEventoBuscaSimples(valor) {
                const valorAjustado = valor.trim()
                if (valorAjustado) {
                    this.resetaPageBuscarTodasMovimentacoesBaixas()
                    this.filtrosInterno.conteudo.value = valorAjustado
                    await this.buscar()
                }
            },
            async tratarEventoPaginar(paginacao) {
                this.setPaginacaoBuscarTodasMovimentacoesBaixas(paginacao)
                this.verificarOrdenacao(paginacao)
                await this.buscar()
            },
            async tratarEventoRemoverFiltro(propriedade) {
                if (this.filtrosInterno[propriedade]) {
                    this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
                }
                this.resetarListagem()
            },
            async resetarListagem() {
                this.setFiltrosBuscarTodasMovimentacoesBaixas(this.getFiltrosInterno())
                await this.buscar()
            },
            verificarOrdenacao(paginacao) {
                if (!this.$store.state.movimentacao.todasMovimentacoesBaixas.paginacao.sortBy[0]) {
                    this.$store.state.movimentacao.todasMovimentacoesBaixas.paginacao.sortBy[0] = paginacao.defaultSortBy
                }
            }
        }
    }
</script>
<style lang="stylus">
.searchMovimentacaoBaixaListagem .input-search
    background-color #fff !important
    width 36vw !important

    span
        max-width 350px

    .v-chip__content
        width 100%

        span
            white-space nowrap
            overflow hidden
            text-overflow ellipsis

@media (max-width 1250px)
    .searchMovimentacaoBaixaListagem .input-search
        background-color #fff !important
        width 40vw !important

        span
            max-width 230px

@media (max-width 890px)
    .searchMovimentacaoBaixaListagem .input-search
        background-color #fff !important
        width 50vw !important

@media (max-width 720px)
    .searchMovimentacaoBaixaListagem .input-search
        background-color #fff !important
        width 55vw !important

#azSearch
    .btn-advanced-search
        background-color var(--v-primary-base) !important

    .az-search-items .v-text-field .v-label--active
        transform: translateY(-24px)
</style>
